module.exports = __webpack_public_path__ + "img/p20.329e49a0.png";